import * as React from "react";
import styles = require("./CircularProgressbar.less");

const MIN_PERCENTAGE = 0;
const MAX_PERCENTAGE = 100;

interface CircularProgressbarProps {
  percentage: number;
  strokeWidth: number;
  image: string;
}

class CircularProgressbar extends React.Component<CircularProgressbarProps, {}> {
  constructor(props: CircularProgressbarProps) {
    super(props);
  }

  getPathDescription() {
    const radius = this.getRadius();
    return `
      M 50,50 m 0,-${radius}
      a ${radius},${radius} 0 1 1 0,${2 * radius}
      a ${radius},${radius} 0 1 1 0,-${2 * radius}
    `;
  }

  getProgressStyle() {
    const diameter = Math.PI * 2 * this.getRadius();
    const truncatedPercentage = Math.min(Math.max(this.props.percentage, MIN_PERCENTAGE), MAX_PERCENTAGE);
    return {
      strokeDasharray: `${diameter}px ${diameter}px`,
      strokeDashoffset: `${((100 - truncatedPercentage) / 100 * diameter)}px`,
      fill: "#fff"
    };
  }

  getRadius() {
    return (50 - this.props.strokeWidth / 2);
  }

  render() {
    const pathDescription = this.getPathDescription();

    return (
      <svg
        className={styles.CircularProgressbar}
        viewBox="0 0 100 100"
      >
        <path
          className={styles.CircularProgressbarTrail}
          d={pathDescription}
          strokeWidth={this.props.strokeWidth}
          fillOpacity={1}
        />

        <path
          className={styles.CircularProgressbarPath}
          d={pathDescription}
          strokeWidth={this.props.percentage === 0 ? 0 : this.props.strokeWidth}
          fillOpacity={1}
          style={this.getProgressStyle()}
        />
        <image
          xlinkHref={this.props.image}
          x={25}
          y={27}
          width="50"
          height="45"
        />
      </svg>
    );
  }
}

export default CircularProgressbar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/GettingStarted/CircularProgressbar.tsx